// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys.

export const environment = {
    production: false,
    stage: 'develop',
    serverUrl: '/api',
    defaultLanguage: 'en-US',
    supportedLanguages: ['en-US', 'es-MX'],
    apiUrl: 'https://api.brandfactore.com/v1/',
    api2Url: 'https://gd4w3ulqvg.execute-api.us-east-1.amazonaws.com/prod/',
    apiDashboards:
        'https://g7dyxff6xb.execute-api.us-east-1.amazonaws.com/prod/',
    apiDashboards2:
        'https://zt80mdaku2.execute-api.us-east-1.amazonaws.com/prod/',
    apiDashboardPremiums:
        'https://rtpkj9pic2.execute-api.us-east-1.amazonaws.com/prod/',
    apiDashboardsRfqPC:
        'https://t9apn16byf.execute-api.us-east-1.amazonaws.com/prod/',
    apiDashboardPremiumPC:
        'https://3q5rj7630e.execute-api.us-east-1.amazonaws.com/prod/',
    apiClients: 'https://csgex680qb.execute-api.us-east-1.amazonaws.com/prod/',
    apiSeller: 'https://v0pihber09.execute-api.us-east-1.amazonaws.com/prod/',
    apiAdminSeller:
        'https://13fyea4y00.execute-api.us-east-1.amazonaws.com/prod/',
    apiSlsBfJiraSlack:
        'https://an3noadrne.execute-api.us-east-1.amazonaws.com/prod/',
    apiProductClasification:
        'https://dg0gm28fmb.execute-api.us-east-1.amazonaws.com/prod/',
    apiSyncDashboards:
        'https://f4uo6lf3mh.execute-api.us-east-1.amazonaws.com/prod/',
    apiProductsSales:
        'https://snc6vem7se.execute-api.us-east-1.amazonaws.com/prod/',
    apiProductsPremiumCharts:
        'https://nm9tab8ffj.execute-api.us-east-1.amazonaws.com/prod/',
    apiProductsPremiumTables:
        'https://h6zex50w04.execute-api.us-east-1.amazonaws.com/prod/',
    apiPremiumTables:
        'https://7z72eih3l6.execute-api.us-east-1.amazonaws.com/prod/',
    apiAgents: 'https://jsuwm46wq7.execute-api.us-east-1.amazonaws.com/prod/',
    apiPremiumSquares:
        'https://842tbore92.execute-api.us-east-1.amazonaws.com/prod/',
    apiPremiumCharts:
        'https://jsxzj6yum1.execute-api.us-east-1.amazonaws.com/prod/',
    apiNotifications:
        'https://crgy6lwz9h.execute-api.us-east-1.amazonaws.com/prod/',
    apiPopSquares:
        'https://j4kgmu0dvl.execute-api.us-east-1.amazonaws.com/prod/',
    apiPopDashboards:
        'https://p4kln7pvzf.execute-api.us-east-1.amazonaws.com/prod/',
    apiPopTables:
        'https://2e0qm9wl4c.execute-api.us-east-1.amazonaws.com/prod/',
    apiPopProcessCompleted:
        'https://zuqu73ck7c.execute-api.us-east-1.amazonaws.com/prod/',
    apiPopDashboadsRfqs:
        'https://thhzdcn407.execute-api.us-east-1.amazonaws.com/prod/',
    apiConekta: 'https://56labxl61l.execute-api.us-east-1.amazonaws.com/dev/',
    apiLogistic: 'https://n6kdfbukyh.execute-api.us-east-1.amazonaws.com/prod/',
    apiShippo:
        'https://24uqnhexv3.execute-api.us-east-1.amazonaws.com/prod/list-shippo-orders',
    apiShippoShipments: 'https://api.goshippo.com/shipments',
    apiShippoOrders: 'https://api.goshippo.com/orders',
    apiShippoRates: 'https://api.goshippo.com/rates',
    apiShippoTransactions: 'https://api.goshippo.com/transactions',
    apiShippoAddresses: 'https://api.goshippo.com/addresses',
    apiShippoParcels: 'https://api.goshippo.com/parcels',
    apiShippoTracks: 'https://api.goshippo.com/tracks',
    apiShippoRefunds: 'https://api.goshippo.com/refunds',
    apiShippoManifests: 'https://api.goshippo.com/manifests',
    apiShippoCustomsItems: 'https://api.goshippo.com/customs/items',
    apiShippoCustomsDeclarations:
        'https://api.goshippo.com/customs/declarations',
    apiShippoCarrierAccounts: 'https://api.goshippo.com/carrier_accounts',
    apiShippoCarriers: 'https://api.goshippo.com/carriers',
    apiShippoToken: 'shippo_test_b9c192807cd2b558c40247d65ab158b966b8cd00',
    apiCreateLocation:
        'https://24uqnhexv3.execute-api.us-east-1.amazonaws.com/prod/create-location',
    apiAlendum: 'https://6kr6h8uy6i.execute-api.us-east-1.amazonaws.com/dev/',
    apiProductsUsa:
        'https://v0r25kohzh.execute-api.us-east-1.amazonaws.com/prod/',
    slsDbPreProcSubp:
        'https://ane08ys4c8.execute-api.us-east-1.amazonaws.com/prod/',
    slsCrmJiraUrl:
        'https://fo58n7jvzk.execute-api.us-east-1.amazonaws.com/dev/',
    apiClip: 'https://api-gw.payclip.com/checkout',
    apiPakMailUrl: 'https://500.api.pakmail.com.mx/api/v1/',
    apiPakMailKey: '95a64542cbc0093dda7a55b24f2c8a07',
    clipApiSecret: 'bc3aeffd-476b-48ce-9c88-85b0fd65a773',
    clipApiKey: '5ba14f0a-f469-4898-9d53-ba5c6b07914d',
    etPay: {
        merchantCode: 'mx_brand_factory',
        merchantApiToken:
            '3TzLw8Bo9s30jiu4QfP4dvddgUvG8F0OWzSes40ZYPR4YLdI0sGgGsZlwo9JU17o',
        apiUrl: 'https://mx-api.etpay.com',
        pmtUrl: 'https://qt.etpay.com',
        apiPlatformUrl: 'https://api-dashboard.etpay.com'
    },
    stripe: {
        apiUrl: 'https://api.stripe.com/v1',
        publishableKey:
            'pk_test_51RGlFhCVsQtmcnKQ3kMGsRPNmxj6h7ZhEgjGBeLjJ9cWXqq58UJuOQyDqsRtrpgkPOm37MxyDLdD7k71c8xFfVZ000Ep8odP5y',
        secretKey:
            'sk_test_51RGlFhCVsQtmcnKQTmxV0ge4obalqUQrF4NP2PqOoGc0DFFlaPooCDhvMHhyE3jcOsQqmjZVFpkgN5sW7crBchmF00dGCq0sop'
    },
    crmUrl: 'https://develop.d2ot0ibkt8plur.amplifyapp.com/crm',
    mailTo: 'notificationsdev@brandfactory.marketing',
    rfqMail: 'rfqdev@brandfactory.marketing',
    configS3: {
        region: 'us-east-1',
        credentials: {
            accessKeyId: 'AKIAUUWHK2RKHZB57VNC',
            secretAccessKey: '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'
        }
    },
    bucketImages: 'source-data-bf-images-sageqa',
    bucketDocuments: 'source-data-docs-bf-devsage',
    urlImages:
        'https://source-data-bf-images-sageprod.s3.us-east-1.amazonaws.com/',
    urlApp: 'https://www.brandfactore.com/',
    coupaClients: {
        procter: {
            id: '111111111111111111111111111111111111',
            url: 'https://pg-stage.coupahost.com/punchout/checkout?id=313',
            quality: 'Pablo Becerra'
        },
        herdez: {
            id: '3522201c-15d7-4493-bfb0-929d96dc32ed',
            url: 'https://grupoherdez-test.coupahost.com/punchout/checkout?id=6'
        },
        shell: {
            id: '9adcc607-bb45-4365-83b8-6ca855a9674e',
            url: 'https://dev.brandfacotry.marketing'
        },
        reckitt: {
            id: '004ece07-d59a-48b1-9919-dd854928a15d',
            url: 'https://dev.brandfacotry.marketing'
        },
        scotiabank: {
            id: '76d4069f-f5e3-4722-8d4f-7fc789f97315',
            url: 'scotiabanklifeshop.com'
        },
        danone: {
            id: 'baf8e795-51dd-4bef-a707-81012ca29a1e',
            url: 'https://danone-test.coupahost.com/punchout/checkout?id=127'
        },
        danone2: {
            id: 'baf8e795-51dd-4bef-a707-81012ca29a1e',
            url: 'https://danone-test.coupahost.com/punchout/checkout?id=127'
        },
        danone3: {
            id: 'baf8e795-51dd-4bef-a707-81012ca29a1e',
            url: 'https://danone-test.coupahost.com/punchout/checkout?id=127'
        },
        danone4: {
            id: 'baf8e795-51dd-4bef-a707-81012ca29a1e',
            url: 'https://danone-test.coupahost.com/punchout/checkout?id=127'
        },
        didi: {
            id: '21fca75c-88b3-4aff-843e-bb104ae3cced',
            url: 'scotiabanklifeshop.com'
        },
        sherwin: {
            id: '0d940b1e-3615-4449-84e5-89ded306db4f',
            url: 'https://sherwin-stage.coupahost.com/punchout/checkout?id=84'
        },
        pqp: {
            id: '0d940b1e-3615-4449-84e5-89ded306db4f',
            url: 'https://sherwin-stage.coupahost.com/punchout/checkout?id=87'
        },
        hogares: {
            id: '1ed7b37b-f8ac-42c5-b3e2-90818f184f3a',
            url: 'hogaresunion'
        },
        mattel: {
            id: 'dce01194-fbcf-4722-9588-9da9943beb18',
            url:
                'https://mattel-test.coupahost.com/punchout/checkout_test?id=34'
        },
        mattel2: {
            id: 'dce01194-fbcf-4722-9588-9da9943beb18',
            url: 'https://mattel-test.coupahost.com/punchout/checkout?id=34'
        },
        mattel3: {
            id: 'dce01194-fbcf-4722-9588-9da9943beb18',
            url: 'https://mattel-test.coupahost.com/punchout/checkout?id=34'
        },
        loreal: {
            id: 'e6134384-fc28-4115-8e0b-1c305e0eac00',
            url: 'https://mattel-test.coupahost.com/punchout/checkout?id=34'
        },
        mediCommerce: {
            id: 'd09ab57f-02f0-4470-93dc-81b89889d764',
            url: ' '
        },
        mediCommerceProvider: {
            id: '95931475-38f3-4a39-a50a-905d2228d563',
            url: ' '
        },
        mapfre: {
            id: '7144b6c4-0014-4bf3-af3e-1806487f063a',
            externalIds: ['629efa04-508d-49d9-9dfd-9a011990d4a8'],
            url: ''
        }
    },
    senderDomain: 'brandfactory.marketing',
    DUNS: 951566458,
    SharedSecret: '1kMpkwwd^KABGC3R69#t',
    subcategoryDiscountId: 'c20a3d67-8110-4bd8-b32a-6d9b73e82e94',
    BuyerCookie: '022fcf9200c90a4317c38663f97f6adb',
    Identity: 'sourcedata',
    enableOnlinePayments: true,
    notificationTypes: {
        EMAIL: 'Email',
        NGZORRO: 'Ng zorro',
        BROWSER: 'Browser'
    },
    categoriesMercadolibre: {
        categoryId: '81c46037-0e18-4f60-bde9-0be1c658cc37',
        categoryName: 'MERCADOLIBRE',
        subcategoryId: '74a1e69d-fc19-4d8b-942a-61bf0c3940a8',
        subcategoryName: 'MERCADOLIBRE',
        defaultProviderId: '884f8953-0629-4223-9609-5ddcde77b4b4'
    },
    bigSmartUrl: 'https://api.bigsmart.mx/',
    bigSmartToken:
        // tslint:disable-next-line: max-line-length
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiOTFlNTc2YWU5MzVmMzJlZjkzNjM0NWQyZWQxNTFkNDJiNTI4MTU3YzA1Y2EyMDJlNjE4NzQ4ODE3ZjdkNTEyOTk1ZGU4MDQxMDFmMTFmMjkiLCJpYXQiOjE2OTkzMTU2NjkuMzg2NDk4LCJuYmYiOjE2OTkzMTU2NjkuMzg2NSwiZXhwIjoxNzMwOTM4MDY5LjM3NTM0NCwic3ViIjoiODQ1MCIsInNjb3BlcyI6W119.srscIkEJjF8l4q9uIjhnaED-lIfRsZT_fSZ6arJbz338KZNyse41SjCrKDm0Xf5GqN0egUqxd8F-4UKibDQVcs1KS47wuJIwBlC2BB0LQrOe-d0Kw5CvXbK-2Xi9exykPC4tuN-h0IUqNQNRKCGFfaupUvvjZd3ke0w0H0FUDsGFmvQgB9nr9JSkE3K7uUg4f_BjJAODil0g9xSPnhdTI0nNPyO_d60c9BGLi9iHMjYvDf2MABV3NvdQvl9cnE_QJimSYf6NJ0SKha9eoMZ9dxClNJK5_ww9-bxeqrM_-q8lRfYC6YP8SG3rYOqPX9KyYq-oQNIQro1qU2iRXkz_1-tPKumYhukkT3pt4XzH9Li1r4XwQB7zKrjMU4gLoc1bNTabe-_RdQcwarFXZTL1xbsZOlneSAz7E6p0oHVbhM296TeaPBdvnRI3mouSzVAOJ1I1b7AorftwGavxEE-MasygGnyamSpDBUBoo_ElFzbq6Y31ngFLdTl7CX29ODhFH2MGVKfgeq1CVFeVmTmRvrKoJ_ire_pDOe7GMlR4KClgweTVbU90ATw0egVyIG4Idkp-mCUrMa8OtJ8cHYqxo1xiiRgIGBZpVx3mvJbmTjXchat-Ft1678MUJYlHyAqJDUmd-jmqn1_3b9QZQkbsXQGlqr_QAFYVYii7q2t1i18',
    urlDocusign: 'http://34.232.209.35',
    autosmails: ['omar@brandfactory.marketing'],
    billingmails: [
        {
            name: 'Omar Martínez',
            email: 'omar@brandfactory.marketing'
        },
        {
            name: 'Agustin Rangel',
            email: 'agustin@brandfactory.marketing'
        }
    ],
    shellAditionalApprovers: {
        'jessica.sotomayor@shell.com': [
            {
                name: 'Ximena Maeso',
                email: 'maria-ximena.maeso@shell.com',
                authorized: false
            },
            {
                name: 'Karla Lazcano',
                email: 'karla.lazcano@shell.com',
                authorized: false
            }
        ],
        'karla.lazcano@shell.com': [
            {
                name: 'Ximena Maeso',
                email: 'maria-ximena.maeso@shell.com',
                authorized: false
            }
        ]
    },
    adminEmails: ['omar@brandfactory.marketing'],
    pingId: {
        verifyDomain: 'procterprod',
        cognitoHostedUi:
            'https://auth0brand.auth.us-east-1.amazoncognito.com/login?client_id=5tupchdjerf2k9e3ib55cup1e0&response_type=token&scope=email+openid+profile&redirect_uri=https%3A%2F%2Fd1qccdtp3qsc3y.cloudfront.net'
    },
    coupaSub: '5123ba7f-c481-40c2-b8c2-a199d5cfc941',
    sourceDataProviderId: '9c3324e6-c88d-48f4-bf75-60c508298f34', //sourcedata
    automobilesLimitDate: 20,
    // --- Llaves nuevas traídas de develop (revisar valores para sage) ---
    warehouseUrl: 'https://develop.dewrlmr32ecqa.amplifyapp.com/',
    loggerSystemUrl: 'https://develop.d30h7f03zc78k7.amplifyapp.com/',
    learningSystemUrl: 'https://develop.dzbd5rbcaldw3.amplifyapp.com/',
    atcSystemUrl: 'https://develop.d3s7zu0imwfoln.amplifyapp.com/',
    /** Base URL for SLS Logger API (no trailing slash). Used by SlsLoggerService. */
    slsLoggerBaseUrl:
        'https://f2vtpfmt3e.execute-api.us-east-1.amazonaws.com/dev/',
    /** API key for SLS Logger (list logs + create via ingest). */
    slsLoggerApiKey: 'ABC123abc',
    showPublicPrices: false,
    sourceDataClientId: 'a3f0dd51-5230-4b01-a084-d8b00393a740',
    jira: {
        assignee_id: '712020:220f5083-57de-4394-9a55-0f8ec66880e8',
        projectKeys: {
            op: 'OPDEV',
            ot: 'OTDEV',
            oc: 'OCDEV',
            of: 'OFDEV'
        },
        userGroups: {
            operations: 'OPERACIONES_DEV',
            admonFinance: 'ADMINISTRACION_Y_FINANZAS_DEV'
        }
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
